<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>自学成才系统</el-breadcrumb-item>
        <el-breadcrumb-item>自学成才报名管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams">
        <el-row :gutter="24">
          <el-col :span="5">
            <el-form-item label="手机号：" prop="mobile">
              <el-input v-model="listParams.mobile" size="small" placeholder="请输入手机号" style="float: left; width: 150px" clearable> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-button size="small" @click="searchData" style="margin-top: 4px"> 查询 </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="margin-bottom: 40px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table :data="tableData" max-height="800" border>
        <el-table-column prop="name" align="center" label="姓名"> </el-table-column>

        <el-table-column prop="" align="center" label="提交时间">
          <template slot-scope="scope">
            <span>{{ scope.row.applyDate | formatDate }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="mobile" align="center" label="手机号"> </el-table-column>

        <el-table-column prop="range" align="center" label="报读层次"> </el-table-column>

        <el-table-column prop="school" align="center" label="报读院校"> </el-table-column>

        <el-table-column prop="profession" align="center" label="报读专业"> </el-table-column>

        <el-table-column prop="province" align="center" label="所在省份"> </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      listParams: {
        mobile: "",
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    searchData() {
      this.pager.pageIndex = 1;
      this.loadTableData();
    },
    loadTableData() {
      this.formLoading = true;
      const bodyParams = Object.assign(
        {},
        {
          mobile: this.listParams.mobile,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        }
      );
      this.$http({
        url: global.apiUrl + "/selftaught/list",
        methods: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            this.tableData = res.body.data.dataList;
            this.pager.total = res.body.data.total;
          } else {
            this.tableData = [];
            this.pager.total = 0;
            this.formLoading = false;
          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>
<style></style>
